var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Database--Streamline-Core-Gradient.svg",
    height: 14,
    width: 14,
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Database Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free Gradient/Computer Devices/database--raid-storage-code-disk-programming-database-array-hard-disc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "url(#paint0_linear_14402_12618)",
    fillRule: "evenodd",
    d: "M2.57787 1.20923C3.73421.764488 5.29782.5 7 .5c1.70218 0 3.2658.264488 4.4221.70923.5765.22174 1.0774.49801 1.4428.83028.3655.3324.6351.76022.6351 1.26818v.1224c-.0487.14282-.1511.30562-.3365.48586-.2865.27835-.7336.55785-1.3369.8059-1.2038.49486-2.90988.81554-4.82664.81554-1.91675 0-3.62287-.32068-4.82659-.81554-.60336-.24805-1.05044-.52755-1.336897-.8059C.651072 3.7358.548777 3.57309.5 3.43031v-.12262c0-.50796.269585-.93578.63512-1.26818.3654-.33227.86625-.60854 1.44275-.83028ZM.5 5.24559v2.0311c.055818.12615.153631.26658.311814.41973.287686.27853.736666.55821 1.342496.80638 1.20861.49508 2.92143.81584 4.84554.81584 1.92412 0 3.63695-.32076 4.84555-.81584.6058-.24817 1.0548-.52785 1.3425-.80638.1585-.15342.2563-.29407.3121-.42039v-2.0305c-.3496.23964-.7553.45036-1.1982.63243-1.3883.57074-3.26306.90943-5.30184.90943-2.03878 0-3.91358-.33869-5.30188-.90943C1.25524 5.69591.849566 5.4852.5 5.24559Zm11.8192 4.41392c.4354-.17834.8349-.38418 1.1808-.61777v1.65066c0 .5078-.2696.9356-.6351 1.2679-.3654.3322-.8662.6085-1.4427.8303C10.2659 13.2354 8.70228 13.5 7 13.5s-3.2659-.2646-4.42221-.7094c-.57649-.2218-1.0773-.4981-1.44267-.8303C.769638 11.628.5 11.2002.5 10.6924V9.04193c.345787.23351.74523.43929 1.18048.61758 1.39275.57049 3.27372.90909 5.31937.90909 2.04566 0 3.92665-.3386 5.31935-.90909Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14402_12618",
    x1: 2.625,
    x2: 13.125,
    y1: 3,
    y2: 8.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe70d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbd0d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsIcon);
export default __webpack_public_path__ + "static/media/coins-icon.1a35cec67555eedbcde1067d6da18fad.svg";
export { ForwardRef as ReactComponent };